import { ssoApi } from "../api/sso";
import { getAuthSettings } from "../auth/settings";

export class RefreshTokenService {
  private isRefreshing = false;
  private subscribers: { resolve: (value: boolean) => void }[] = [];

  do(): Promise<boolean> {
    return this.getPromise();
  }

  private async getPromise(): Promise<boolean> {
    const shouldRequest = !this.isRefreshing;
    if (!this.isRefreshing) {
      this.isRefreshing = true;
    }
    const promise = new Promise<boolean>((resolve) => {
      this.subscribers.push({ resolve });
    });

    if (shouldRequest) {
      setTimeout(async () => {
        await this.refreshToken();
      }, 0);
    }

    return promise;
  }

  private async refreshToken(): Promise<void> {
    const { clientId, userFlowSignIn, cookieTarget } = getAuthSettings();

    try {
      await ssoApi.refreshToken({ clientId, userFlow: userFlowSignIn, cookieTarget });
      this.notifySubscribers(true);
    } catch {
      this.notifySubscribers(false);
    }
  }

  private notifySubscribers(result: boolean): void {
    this.subscribers.forEach((subscriber) => subscriber.resolve(result));
    this.subscribers = [];
    this.isRefreshing = false;
  }
}

const refreshTokenService = new RefreshTokenService();

export default refreshTokenService;
